import React from "react";
import { useRouter } from "next/router";
import { SwitchTransition, CSSTransition } from "react-transition-group";

import styles from "./PageTransitions.module.css";

const TRANSITION_DURATION = 300;

const PageTransitions: React.FC<React.PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const nodeRef = React.useRef(null);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={router.pathname}
        nodeRef={nodeRef}
        timeout={TRANSITION_DURATION}
        classNames={{
          enter: styles.transitionEnter,
          enterActive: styles.transitionEnterActive,
          exit: styles.transitionExit,
          exitActive: styles.transitionExitActive,
        }}
      >
        <div ref={nodeRef} className={styles.pageTransitionWrapper}>
          {children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default PageTransitions;
